import(/* webpackMode: "eager" */ "/app/app/[lang]/pl/restaurantweek/restaurantweek-pl-global.css");
import(/* webpackMode: "eager" */ "/app/components/Toast/ToastUtils.tsx");
import(/* webpackMode: "eager" */ "/app/components/Toast/ToastView.tsx")